var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path, _path2, _path3, _polygon8, _polygon9, _path4, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _path5, _path6, _path7, _rect, _rect2, _polygon54, _rect3, _rect4, _rect5, _polygon55, _polygon56, _polygon57, _rect6, _rect7, _rect8, _rect9, _rect10, _polygon58, _rect11, _rect12, _rect13, _rect14, _polygon59, _rect15, _rect16, _polygon60, _rect17, _rect18, _polygon61, _rect19, _rect20, _rect21, _rect22, _rect23, _polygon62, _rect24, _rect25, _rect26, _rect27, _rect28, _polygon63, _rect29, _rect30, _rect31, _rect32, _polygon64, _rect33, _rect34, _rect35, _polygon65, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _polygon66, _polygon67, _polygon68, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _polygon69, _rect55, _polygon70, _rect56, _rect57, _rect58, _polygon71, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _polygon72, _polygon73, _rect76, _rect77, _polygon74, _rect78, _rect79, _rect80, _rect81, _rect82, _polygon75, _rect83, _rect84, _rect85, _rect86, _polygon76, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _polygon77, _rect99, _polygon78, _rect100, _polygon79, _rect101, _rect102, _polygon80, _polygon81, _rect103, _rect104, _rect105, _rect106, _rect107, _polygon82, _rect108, _rect109, _polygon83, _rect110, _polygon84, _rect111, _polygon85, _rect112, _rect113, _rect114, _polygon86, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _polygon87, _polygon88, _polygon89, _rect126, _rect127, _polygon90, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _rect134, _polygon100, _polygon101, _path8, _polygon102, _polygon103, _polygon104, _polygon105, _path9, _rect135, _path10, _path11, _rect136, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon106, _line, _path35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoflights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 827.4 578.2",
    style: {
      enableBackground: "new 0 0 827.4 578.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B2B2B2;}\n\t.st1{fill:#D6D6D6;}\n\t.st2{fill:#FFFFFF;stroke:#9B9B9B;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st3{fill:#CECECE;}\n\t.st4{fill:#757575;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#0393BB;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F5F5;}\n\t.st7{fill:none;}\n\t.st8{fill:#FFFFFF;stroke:#D1D1D1;stroke-width:3;stroke-miterlimit:10;}\n\t.st9{fill:#969696;}\n\t.st10{fill:none;stroke:#9B9B9B;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3,3;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.5,425.2 97.8,431.2 97.7,431.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "97.3,437.1 97.1,443.1 96.8,443.1 97.1,437.1 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "97.1,449.1 97.3,455.1 96.8,455.1 96.6,449.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "97.8,461.1 98.5,467 97.8,467.1 97.1,461.1 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "99.6,472.9 100.9,478.7 99.9,479 98.7,473.1 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "102.6,484.5 104.6,490 103.5,490.5 101.5,484.8 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.1,495.5 110,500.6 108.9,501.3 106,496 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.4,505.5c1.2,1.6,2.5,3,3.9,4.5l-1.1,1c-1.4-1.5-2.7-3-3.9-4.6L113.4,505.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.6,513.9c1.5,1.3,3.1,2.4,4.8,3.5l-0.9,1.4c-1.7-1.1-3.3-2.3-4.9-3.6L121.6,513.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.6,520.3c1.8,0.9,3.6,1.6,5.4,2.3l-0.6,1.6c-1.9-0.7-3.8-1.5-5.6-2.4L131.6,520.3z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "142.6,524.4 148.4,525.6 148.1,527.4 142.2,526.1 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "154.3,526.3 160.2,526.6 160.2,528.6 154.1,528.2 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.2,526.5l3-0.2c1-0.1,2-0.1,2.9-0.2l0.2,2.1c-1,0.1-2,0.1-3,0.2l-3,0.2L166.2,526.5z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.9,525.2 183.6,523.6 184.2,525.8 178.3,527.3 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "189.1,521.7 194.6,519.3 195.6,521.4 190,523.8 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "199.9,516.7 205.1,513.8 206.3,515.9 201,518.8 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "210.2,510.7 215.2,507.4 216.6,509.5 211.5,512.8 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "220.1,504 224.9,500.5 226.4,502.6 221.6,506.1 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "229.6,496.9 234.3,493.1 235.9,495.2 231.2,498.9 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "238.9,489.3 243.4,485.5 245.2,487.5 240.6,491.4 "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "247.9,481.5 252.4,477.5 254.2,479.5 249.7,483.5 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "256.8,473.4 261.1,469.3 263,471.3 258.6,475.4 "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "265.4,465.2 269.7,461 271.6,462.9 267.3,467.1 "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "273.9,456.7 278.1,452.5 280.1,454.4 275.9,458.7 "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "282.3,448.2 286.4,443.8 288.5,445.8 284.3,450.1 "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "290.5,439.5 294.6,435.1 296.7,437.1 292.6,441.4 "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "298.7,430.7 302.7,426.3 304.9,428.2 300.8,432.7 "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "306.7,421.8 310.7,417.4 312.9,419.3 308.9,423.8 "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.7,412.9 318.7,408.4 320.9,410.3 316.9,414.8 "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "322.6,403.9 326.5,399.3 328.8,401.3 324.9,405.8 "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "330.5,394.8 334.4,390.3 336.6,392.2 332.7,396.7 "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "338.3,385.7 342.1,381.1 344.4,383 340.5,387.6 "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "346,376.6 349.9,372 352.1,373.8 348.2,378.4 "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "353.7,367.4 357.6,362.8 359.7,364.5 355.9,369.2 "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "361.4,358.1 365.2,353.5 367.4,355.3 363.5,359.9 "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "369,348.9 372.8,344.2 374.9,346 371.1,350.6 "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "376.6,339.6 380.4,335 382.5,336.7 378.7,341.3 "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.2,330.3 388,325.6 390,327.3 386.3,332 "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.8,321 395.5,316.3 397.6,318 393.8,322.6 "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "399.3,311.6 403.1,307 405.1,308.6 401.3,313.3 "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "406.8,302.3 410.6,297.6 412.6,299.2 408.8,303.9 "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "414.4,293 418.1,288.3 420,289.8 416.3,294.5 "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "421.9,283.6 425.7,279 427.5,280.4 423.8,285.1 "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "429.5,274.3 433.2,269.6 434.9,271 431.2,275.7 "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "437,265 440.8,260.3 442.4,261.6 438.7,266.3 "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "444.6,255.6 448.4,251 449.9,252.2 446.1,256.9 "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "452.2,246.3 456,241.7 457.4,242.8 453.6,247.5 "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "459.8,237 463.6,232.4 464.9,233.5 461.2,238.2 "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467.4,227.8 471.2,223.2 472.5,224.2 468.7,228.8 "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.1,218.6 479,213.9 480.1,214.9 476.3,219.5 "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "482.8,209.4 486.7,204.8 487.7,205.7 483.9,210.3 "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "490.6,200.3 494.6,195.7 495.4,196.5 491.6,201.1 "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "498.5,191.2 502.5,186.7 503.2,187.3 499.3,191.9 "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "506.5,182.2 510.6,177.8 511.1,178.3 507.1,182.8 "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "514.6,173.4 518.7,169 519.1,169.4 515.1,173.8 "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "522.9,164.7 527.1,160.4 527.3,160.6 523.2,165 "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "531.3,156.1 535.7,152 535.7,152 531.5,156.3 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.9,332.7c-3.6,9.1-6.6,18.4-9.4,27.8s-5.3,18.8-7.4,28.4c-4.3,19-6.8,38.4-7.4,57.9 c-0.3,9.7,0.2,19.4,1.4,29c0.3,2.4,0.7,4.8,1.1,7.2s0.9,4.8,1.4,7.1c1.1,4.7,2.4,9.3,4,13.9c1.6,4.5,3.5,8.9,5.6,13.2 c2.2,4.3,4.6,8.4,7.4,12.3c5.5,7.8,12.3,14.6,19.9,20.3c3.8,2.8,7.9,5.4,12.1,7.7c4.2,2.2,8.6,4.2,13.1,5.9c9,3.4,18.3,5.8,27.7,7.3 c9.4,1.5,19,1.8,28.5,1.1c9.5-0.8,19-2.5,28.2-5.3c9.2-2.7,18.2-6.2,26.9-10.3c8.7-4.2,17.1-8.9,25.3-14.1 c8.2-5.2,16-10.8,23.8-16.7s15.1-12.2,22.4-18.6c29.1-25.8,55.4-54.8,80.5-84.7s48.8-61,72.5-92.2s46.9-62.7,71.2-93.5 c6.1-7.7,12.3-15.3,18.6-22.8s12.7-15,19.3-22.2s13.3-14.4,20.4-21.2c7-6.8,14.4-13.3,22.2-19.2c-7.5,6.2-14.7,12.9-21.5,20 c-6.8,7-13.3,14.3-19.7,21.7s-12.5,15-18.6,22.7c-6.1,7.7-12,15.4-17.9,23.2c-11.8,15.6-23.4,31.3-34.9,47.2l-34.6,47.5 c-11.6,15.8-23.3,31.5-35.2,47.1c-11.9,15.6-24.1,31-36.5,46.1c-12.5,15.2-25.4,29.9-38.8,44.3c-3.3,3.6-6.8,7.1-10.2,10.7 s-6.9,7-10.4,10.5c-7,7-14.2,13.6-21.6,20.2c-7.3,6.6-15,12.8-22.9,18.8c-7.9,6.1-15.9,11.7-24.3,17c-8.4,5.3-17.1,10.1-26,14.4 c-9,4.3-18.4,7.8-28,10.6c-9.6,2.8-19.5,4.6-29.5,5.3c-10,0.7-20.1,0.2-30-1.4c-2.5-0.4-5-0.8-7.4-1.4c-2.4-0.6-4.9-1.1-7.3-1.8 l-3.6-1c-1.2-0.3-2.4-0.8-3.6-1.2l-3.6-1.2l-3.5-1.4c-4.7-1.8-9.2-4-13.6-6.4c-4.4-2.5-8.6-5.2-12.6-8.3c-8-6.1-15-13.4-20.8-21.7 c-2.8-4.2-5.3-8.5-7.6-13c-0.6-1.1-1-2.3-1.6-3.4c-0.6-1.1-1-2.3-1.5-3.5l-1.4-3.5l-1.2-3.5c-1.6-4.7-2.8-9.5-3.8-14.4 c-0.6-2.4-0.9-4.9-1.3-7.3s-0.7-4.9-1-7.4c-1-9.8-1.3-19.7-0.8-29.6c1.1-19.7,4.1-39.2,9-58.2C61.9,369.4,68.2,350.7,75.9,332.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M392.9,377.2l-0.2-126c0-4.4-3.6-7.9-8-7.9l-176.2,0.3l-178.8,0.3c-4.4,0-7.9,3.6-7.9,7.9c0,0,0,0,0,0.1 l0.2,126c0,4.4,3.6,7.9,8,7.9l128.1-0.2v-0.7h1.2v0.7l49.3-0.1l176.5-0.4C389.4,385.2,392.9,381.6,392.9,377.2L392.9,377.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.8,376.6l-98.4,0.2c-4.7,0-8.6-3.8-8.6-8.6l0,0l-0.2-104.6c0-4.7,3.8-8.6,8.5-8.6l98.4-0.2 c4.7,0,8.6,3.8,8.6,8.6l0.2,104.7C149.3,372.7,145.5,376.5,140.8,376.6z M42.9,374l97.3-0.2c3.2,0,5.8-2.6,5.8-5.8l-0.2-104.7 c0-3.2-2.6-5.8-5.8-5.8c0,0,0,0,0,0l-97.3,0.2c-3.2,0-5.8,2.6-5.8,5.8c0,0,0,0,0,0l0.2,104.7C37.1,371.4,39.7,374,42.9,374 C42.9,374,42.9,374,42.9,374z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 292.7,
    transform: "matrix(1 -3.141572e-03 3.141572e-03 1 -0.92 0.5575)",
    className: "st3",
    width: 1.1,
    height: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 292.9,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "233.9,292.6 233.9,293.4 236,293.4 236,292.6 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 238.1,
    y: 292.6,
    transform: "matrix(1 -4.188778e-03 4.188778e-03 1 -1.2253 1.0041)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225.6,
    y: 292.6,
    transform: "matrix(1 -2.617982e-03 2.617982e-03 1 -0.7664 0.5943)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 292.6,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.7153 0.5648)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "250.6,292.6 250.6,293.4 252.7,293.4 252.7,292.6 "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "254.8,292.6 254.8,293.4 256.9,293.4 256.9,292.5 "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "246.5,292.6 246.4,293.4 248.5,293.4 248.5,292.6 "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 239.7,
    y: 294,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 217.8,
    y: 292,
    transform: "matrix(2.094442e-03 -1 1 2.094442e-03 -75.2376 510.6652)",
    className: "st3",
    width: 0.8,
    height: 2.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 292.7,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 192.1,
    y: 292.7,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.7156 0.4729)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 179.6,
    y: 292.7,
    transform: "matrix(1 -3.316120e-03 3.316120e-03 1 -0.971 0.6006)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "259,292.5 259,293.4 261.1,293.4 261.1,292.5 "
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 292.7,
    transform: "matrix(1 -3.839715e-03 3.839715e-03 1 -1.1239 0.7598)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 183.8,
    y: 292.7,
    transform: "matrix(1 -4.537840e-03 4.537840e-03 1 -1.3281 0.842)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 208.8,
    y: 292.7,
    transform: "matrix(1 -1.047197e-03 1.047197e-03 1 -0.3068 0.2199)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 292.6,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "204.7,292.6 204.7,293.5 206.8,293.5 206.8,292.6 "
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 200.1,
    y: 291.7,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 267.4,
    y: 292.5,
    transform: "matrix(1 -2.094389e-03 2.094389e-03 1 -0.613 0.5628)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "321.6,292.4 321.6,293.3 323.7,293.3 323.7,292.4 "
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 317.5,
    y: 292.4,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.5106 0.5564)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 292.4,
    transform: "matrix(1 -3.490651e-03 3.490651e-03 1 -1.0204 1.0846)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "325.8,292.4 325.8,293.3 327.9,293.3 327.9,292.4 "
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 313.3,
    y: 292.5,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 292.4,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 292.4,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 336.4,
    y: 293.8,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 334.2,
    y: 292.4,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "279.9,292.5 279.9,293.4 282,293.4 282,292.5 "
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 275.8,
    y: 292.5,
    transform: "matrix(1 -3.490651e-03 3.490651e-03 1 -1.0207 0.968)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 263.2,
    y: 292.5,
    transform: "matrix(1 -1.919857e-03 1.919857e-03 1 -0.5619 0.5078)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 304.9,
    y: 292.5,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.7148 0.7485)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 271.5,
    y: 292.5,
    transform: "matrix(1 -1.919857e-03 1.919857e-03 1 -0.5619 0.5238)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 284.1,
    y: 292.5,
    transform: "matrix(1 -1.919857e-03 1.919857e-03 1 -0.5618 0.5479)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "300.8,292.5 300.8,293.3 302.9,293.3 302.9,292.5 "
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 296.6,
    y: 292.5,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 288.2,
    y: 292.5,
    transform: "matrix(1 -4.537840e-03 4.537840e-03 1 -1.3263 1.3156)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 292.4,
    y: 292.5,
    transform: "matrix(1 -1.221729e-03 1.221729e-03 1 -0.3577 0.3587)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 346.7,
    y: 292.4,
    transform: "matrix(1 -3.490651e-03 3.490651e-03 1 -1.0201 1.2138)",
    className: "st3",
    width: 1,
    height: 0.8
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "177.4,308.9 176.3,309 176.3,308.1 177.4,308.1 "
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 229.6,
    y: 308,
    transform: "matrix(1 -2.617982e-03 2.617982e-03 1 -0.8067 0.6048)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 233.8,
    y: 308,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 225.5,
    y: 308,
    transform: "matrix(1 -1.396262e-03 1.396262e-03 1 -0.4304 0.3166)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "258.8,308 258.8,308.8 260.9,308.8 260.9,308 "
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 308,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 237.9,
    y: 308,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 309.1,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 250.5,
    y: 308,
    transform: "matrix(1 -2.094389e-03 2.094389e-03 1 -0.6453 0.5275)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 242.1,
    y: 308,
    transform: "matrix(1 -2.967042e-03 2.967042e-03 1 -0.914 0.7228)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 308,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 218.4,
    y: 309.4,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 308.1,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.5381 0.3374)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 183.6,
    y: 308.1,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 187.8,
    y: 308.1,
    transform: "matrix(1 -1.047197e-03 1.047197e-03 1 -0.323 0.1979)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 308.1,
    transform: "matrix(1 -4.188778e-03 4.188778e-03 1 -1.2907 0.7589)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 200.4,
    y: 308.1,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "208.7,308 208.7,308.9 210.8,308.9 210.8,308 "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196.2,308.1 196.2,308.9 198.3,308.9 198.3,308.1 "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "204.5,308 204.5,308.9 206.6,308.9 206.6,308 "
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 210.9,
    y: 309,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 292.3,
    y: 307.9,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 317.3,
    y: 307.9,
    transform: "matrix(1 -2.617982e-03 2.617982e-03 1 -0.806 0.8345)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 313.8,
    y: 307.3,
    transform: "matrix(1.221725e-03 -1 1 1.221725e-03 5.5051 622.1725)",
    className: "st3",
    width: 0.8,
    height: 2.1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 304.8,
    y: 307.9,
    transform: "matrix(1 -2.792512e-03 2.792512e-03 1 -0.8597 0.8553)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 307.8,
    transform: "matrix(1 -1.047197e-03 1.047197e-03 1 -0.3226 0.338)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 309,
    y: 307.9,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263,308.8 265.1,308.8 265.1,308 263,308 "
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 338.2,
    y: 307.8,
    transform: "matrix(1 -5.585025e-03 5.585025e-03 1 -1.7164 1.8993)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "329.9,307.8 329.9,308.7 331.9,308.7 331.9,307.8 "
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 325.7,
    y: 307.8,
    transform: "matrix(1 -3.316120e-03 3.316120e-03 1 -1.0204 1.0852)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 307.8,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 275.6,
    y: 307.9,
    transform: "matrix(1 -3.839715e-03 3.839715e-03 1 -1.1819 1.0644)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "271.4,308.8 273.5,308.8 273.5,307.9 271.4,307.9 "
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 267.2,
    y: 308,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.7527 0.6563)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 280.3,
    y: 307.3,
    transform: "matrix(2.094442e-03 -1 1 2.094442e-03 -28.1448 588.4311)",
    className: "st3",
    width: 0.9,
    height: 2.1
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 283.4,
    y: 307,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 307.8,
    transform: "matrix(1 -3.665183e-03 3.665183e-03 1 -1.1274 1.2609)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 296.4,
    y: 307.9,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 300.7,
    y: 307.9,
    transform: "matrix(1 -2.967042e-03 2.967042e-03 1 -0.9133 0.8965)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 288.1,
    y: 307.9,
    transform: "matrix(1 -4.188778e-03 4.188778e-03 1 -1.2889 1.214)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 346.6,
    y: 307.8,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.752 0.8491)",
    className: "st3",
    width: 1,
    height: 0.8
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 323.1,
    transform: "matrix(1 -4.188778e-03 4.188778e-03 1 -1.3537 0.7458)",
    className: "st3",
    width: 1.1,
    height: 0.8
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 323,
    transform: "matrix(1 -3.665183e-03 3.665183e-03 1 -1.184 0.8038)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 323,
    transform: "matrix(1 -4.014247e-03 4.014247e-03 1 -1.2962 0.9643)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 234.3,
    y: 323,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 221.8,
    y: 323,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 323,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.5641 0.3968)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 230.1,
    y: 323,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 259.4,
    y: 323,
    transform: "matrix(1 -2.967042e-03 2.967042e-03 1 -0.9584 0.774)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 242.7,
    y: 323,
    transform: "matrix(1 -4.188778e-03 4.188778e-03 1 -1.3525 1.0237)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "251,323 251,323.8 253.1,323.8 253.1,323 "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "246.9,323 246.9,323.8 248.9,323.8 248.9,323 "
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 255.2,
    y: 323,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 188.4,
    y: 323.1,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "192.6,323.1 192.6,323.9 194.6,323.9 194.6,323.1 "
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 184.2,
    y: 323.1,
    transform: "matrix(1 -3.141572e-03 3.141572e-03 1 -1.0153 0.5837)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 323.1,
    transform: "matrix(1 -2.967042e-03 2.967042e-03 1 -0.9591 0.5386)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 342.9,
    y: 322.8,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 196.7,
    y: 323,
    transform: "matrix(1 -1.919857e-03 1.919857e-03 1 -0.6206 0.3803)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 209.2,
    y: 323,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.5642 0.3675)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "205.1,323 205.1,323.9 207.2,323.9 207.2,323 "
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 200.9,
    y: 323,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.5642 0.353)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 213.4,
    y: 323,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 322.9,
    transform: "matrix(1 -1.919857e-03 1.919857e-03 1 -0.6201 0.6208)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 313.7,
    y: 322.9,
    transform: "matrix(1 -1.221729e-03 1.221729e-03 1 -0.3947 0.3848)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "317.9,322.8 317.9,323.7 320,323.7 320,322.8 "
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 309.5,
    y: 322.9,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 323.6,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 263.5,
    y: 322.9,
    transform: "matrix(1 -4.014247e-03 4.014247e-03 1 -1.296 1.0647)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 335.2,
    y: 322.2,
    transform: "matrix(1.919872e-03 -1 1 1.919872e-03 11.7545 658.2504)",
    className: "st3",
    width: 0.8,
    height: 2.1
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 335.9,
    y: 324.7,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 330.4,
    y: 322.8,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 305.3,
    y: 322.9,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 276.1,
    y: 322.9,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 280.2,
    y: 322.9,
    transform: "matrix(1 -2.967042e-03 2.967042e-03 1 -0.9582 0.836)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 322.9,
    transform: "matrix(1 -1.570794e-03 1.570794e-03 1 -0.5075 0.4293)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 267.8,
    y: 322.9,
    transform: "matrix(1 -1.919857e-03 1.919857e-03 1 -0.6203 0.5167)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 285.1,
    y: 322.3,
    transform: "matrix(1.919872e-03 -1 1 1.919872e-03 -38.3606 608.1893)",
    className: "st3",
    width: 0.9,
    height: 2.1
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "297,322.9 297,323.7 299.1,323.7 299.1,322.9 "
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 292.8,
    y: 322.9,
    transform: "matrix(1 -3.490651e-03 3.490651e-03 1 -1.1268 1.0276)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "301.2,323.7 303.3,323.7 303.2,322.9 301.2,322.9 "
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 288.7,
    y: 322.9,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.7891 0.7088)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "348.2,323.6 347.1,323.6 347.1,322.8 348.2,322.8 "
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 176.2,
    y: 338.9,
    className: "st3",
    width: 1.1,
    height: 0.8
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 338.8,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "233.6,338.8 233.6,339.7 235.7,339.7 235.7,338.8 "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "225.3,338.8 225.3,339.7 227.4,339.7 227.4,338.8 "
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 237.8,
    y: 338.8,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.8282 0.5847)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 254.5,
    y: 338.8,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 338.8,
    transform: "matrix(1 -1.396262e-03 1.396262e-03 1 -0.4734 0.3514)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 216.9,
    y: 338.9,
    transform: "matrix(1 -2.094389e-03 2.094389e-03 1 -0.7101 0.4573)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 246.2,
    y: 338.8,
    transform: "matrix(1 -1.221729e-03 1.221729e-03 1 -0.4143 0.3023)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "242,339.6 244.1,339.6 244.1,338.8 242,338.8 "
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 221.1,
    y: 338.8,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 187.7,
    y: 338.9,
    transform: "matrix(1 -2.792512e-03 2.792512e-03 1 -0.9469 0.5283)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "183.5,338.9 183.5,339.8 185.6,339.8 185.6,338.9 "
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 338.9,
    transform: "matrix(1 -2.967042e-03 2.967042e-03 1 -1.006 0.5738)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "179.4,338.9 179.4,339.8 181.4,339.8 181.4,338.9 "
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 338.9,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "208.6,338.9 208.6,339.7 210.7,339.7 210.7,338.9 "
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 196.1,
    y: 338.9,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    y: 338.9,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.5918 0.3737)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 338.9,
    transform: "matrix(1 -1.396262e-03 1.396262e-03 1 -0.4735 0.2814)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "258.7,338.8 258.7,339.6 260.8,339.6 260.8,338.8 "
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 317.2,
    y: 338.7,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 338.7,
    className: "st3",
    width: 2.1,
    height: 0.9
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 325.6,
    y: 338.6,
    transform: "matrix(1 -1.570794e-03 1.570794e-03 1 -0.5322 0.5135)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 338.7,
    transform: "matrix(1 -2.268920e-03 2.268920e-03 1 -0.7686 0.7135)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 338.7,
    transform: "matrix(1 -2.792512e-03 2.792512e-03 1 -0.9458 0.8666)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 305.3,
    y: 338.1,
    transform: "matrix(1.570732e-03 -1 1 1.570732e-03 -33.9193 644.3824)",
    className: "st3",
    width: 0.8,
    height: 2.1
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 338.1,
    y: 338.6,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 342.2,
    y: 338.6,
    transform: "matrix(1 -6.806731e-03 6.806731e-03 1 -2.2999 2.3446)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 333.9,
    y: 338.6,
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 330.3,
    y: 338,
    transform: "matrix(2.792587e-03 -1 1 2.792587e-03 -9.208 668.8388)",
    className: "st3",
    width: 0.8,
    height: 2.1
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 262.8,
    y: 338.8,
    transform: "matrix(1 -1.919857e-03 1.919857e-03 1 -0.6508 0.5073)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "279.6,338.8 279.6,339.6 281.7,339.6 281.7,338.7 "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "275.4,338.8 275.4,339.6 277.5,339.6 277.5,338.8 "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "271.2,338.8 271.2,339.6 273.3,339.6 273.3,338.8 "
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 267.1,
    y: 338.8,
    transform: "matrix(1 -2.967042e-03 2.967042e-03 1 -1.0052 0.797)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: 338.7,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.8277 0.7379)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "296.3,339.6 298.4,339.6 298.4,338.7 296.3,338.7 "
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 292.8,
    y: 338.1,
    transform: "matrix(1.396295e-03 -1 1 1.396295e-03 -46.3809 631.9099)",
    className: "st3",
    width: 0.8,
    height: 2.1
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 338.7,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.5915 0.4977)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 338.7,
    transform: "matrix(1 -2.443451e-03 2.443451e-03 1 -0.8279 0.7072)",
    className: "st3",
    width: 2.1,
    height: 0.8
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 346.4,
    y: 338.6,
    transform: "matrix(1 -2.792512e-03 2.792512e-03 1 -0.9455 0.9702)",
    className: "st3",
    width: 1,
    height: 0.8
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 175.6,
    y: 269.7,
    transform: "matrix(1 -2.617982e-03 2.617982e-03 1 -0.7075 0.5037)",
    className: "st3",
    width: 33,
    height: 1.6
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 208.5,
    y: 269.6,
    transform: "matrix(1 -1.745326e-03 1.745326e-03 1 -0.4714 0.4868)",
    className: "st3",
    width: 140.3,
    height: 1.6
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.7,327.2 114.1,327.2 114,325.9 114.4,326 115.4,325.9 115.3,324.7 112.6,324.7 111.8,323.7  111.9,323.2 108.3,320 107.5,320.7 112.5,326.9 113.2,327.1 113.2,327.5 112.3,327.5 112.5,328.2 118.7,328.5 "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "120.6,323.9 121.1,323.6 121.1,320.3 120.6,320.1 120.4,319 119.8,319 119.4,320.1 118.9,320.5  115.3,322.5 115.3,324.4 116.6,326 119.6,326 120,325 120.6,324.4 "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "123.3,323.6 121.5,324.4 121.5,324.8 121.1,324.8 121.1,327.3 122,327.3 121.9,325.7 122.6,325.9  122.6,327 123.3,327 "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "138.1,336.8 136.3,335.2 136.1,332.2 134.9,330.1 133.8,330 133.4,333.8 131.3,333.7 130.7,333.3  130.6,331.8 131.7,332.1 132.6,331.1 130.6,330 128.3,330 126.6,332.3 125.9,332.4 125.9,331.6 123.9,331.8 120.8,335.4  119.1,335.4 117.2,336.7 117.1,342.4 115.9,343.5 115.9,344.5 121.4,342.5 125.9,342.4 127.5,346 132.6,346.1 137.4,341.5  138.6,338.8 "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "128.2,348.8 130,349 131.4,348.2 131.4,347.1 129.9,346.9 "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "131.3,325.1 130.1,325.1 130.2,323.9 129.1,323.3 127.6,324.8 128.6,326.1 130.9,326.4 132.1,327.1  132.2,327.7 131.4,327.7 131.4,329 134.1,328.8 135.1,327.8 136.2,327.6 136.2,329.6 138.1,329.6 138.1,328.8 137.1,328.8  136.9,326.4 132.5,324.4 "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "98.3,319.5 98.8,320.6 100.3,320 100.5,318.4 99.2,318.2 "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "80,333.1 77.9,332.8 77.9,334.5 78.7,335.4 78.1,336.2 77.2,337.2 77.2,339.1 78.4,340.2 79.5,338.5  81.5,335.4 82.5,330.6 81.3,330.6 "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "123.8,327.9 123.1,327.9 123.1,328.3 123.6,328.5 "
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 119.9,
    y: 328.5,
    transform: "matrix(1 -2.268920e-03 2.268920e-03 1 -0.7455 0.2737)",
    className: "st3",
    width: 0.8,
    height: 0.5
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "121.8,328.9 122.3,328.9 122.3,328.5 122.7,328.5 122.7,328.1 121.9,328.1 121.6,328.5 121.1,328.9  121.1,329.3 121.8,329.2 "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "123.9,329.3 124.8,329.3 124.8,328.9 125.3,328.9 125.3,328.2 124.3,328.3 124.2,328.8 123.2,328.9  123.2,328.9 123.2,329.6 123.9,329.6 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.9,287.1l0.6-0.5l-4.4-1.8l-16-0.8l-1.5-0.8l-2.4-0.3l-1.8,0l-1.6,1.6h-0.7l-2.1-1.7h-6.3l-2.9-1.8 l-5.9,0.4l-4.5,2v2.3l-1.4,0.4l-0.3-2.3l-0.5-0.8l-1.5-0.4l-0.4,1.4l0.5,1.1l-5.5-0.3l-2.6,1.2l-0.4-1.2l-0.7,0.2l-0.5,1.3l-1.4,1.1 l-1.9,0v10.9l0.3-0.1l1.4-0.2l0.3-0.5l0.6,0.3l0.1,1.7l1.6,0.6l0.1,0.8h-1.8l-2.6-0.1v1.8h2.2l1,0.7v1.7l-1.2,1.1H70l0.1,35.3 l1.4-1.4l1.1-2l1.4-0.3V336l0.9-1.1l2-2.7l-0.4-4.1l-0.9-1.5l3.9-3.7l4.2-6.1l-0.8-0.4l-4.4,0.9l-1.1-0.6l-4.6-8.7l0.3-0.4l4.6,5.6 l0.1,1.7l1.1,1.1l2.2-0.2l4.5-3.3l1.4-0.9v-1.1l-1.5-0.2c0,0-5.3-2.5-5.3-2.6s0-2.1,0-2.1h1.2l0.2,1.5l2.4,1.4l2.8,0.1l6.1,1 l1.4,0.9v1.4l-0.2,1.9l3.1,5.1l1,0.2l1-1.5l0.5-4.2l1-2.2l1.7-0.6l2.9,0.3l3.7,3.3v4.7l4.9,4.7l0.2-0.8l-4-5.7l0.4-1.7l2.1,2.4 l1.2,0.1l1.5-1l-0.3-1.5l-2.5-2l-0.1-1.8l0.7-1l1.3,0.4l-0.1,0.9l0.7,1.1l0.7-0.5l-0.4-1.3l3.6-1.3l1.6-1.3l-0.2-2.4l-3.1-3.3 l-0.1-2.7h1.4l4.3,3.3l1.2-0.3l-0.8-1.1l-2.3-1.4l0.1-2.1h2.8l0.2-2.6l-1-1.4l0.6-0.7l1.4,1.3l0.4-0.6l-1.7-2l-4.3-0.5l-0.6-1.1 l1.2-1.8l1,0.7l2.9,0.2l3.7-2.5l0.6,0.8l-0.8,1.3v1.3l3.4,2.8l1.1-0.6l-0.4-1.9l-2.4-2.2l3.2-0.2v-0.9l1.6-0.3l-1.2-0.8v-0.6 L135.9,287.1z M82.8,302.2l-0.5,0.4l-1.1-0.1l-0.2-0.3l-1.7-0.1l0.1-0.5l0.9-0.8v-0.7l-1.7-1.2l-0.1-1.6l0.3-0.8l1.4-0.1l1.2,0.5 l0.1,0.8l-1.7-0.1l-0.1,0.8l2.1,1.4v1l0.9,0.7L82.8,302.2z"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "71.9,286.4 72.6,285.8 69.9,284.6 69.9,286.5 "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "53.1,292.6 53.2,293.3 52.2,293.5 52,294.9 53.2,294.9 54.8,294.7 55.6,293.8 54.8,293.4 54.3,292.9  53.6,291.7 53.2,290 51.9,290.3 51.5,290.9 51.5,291.6 52.1,292 "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "51.9,293.1 52,292.2 51.2,291.9 50.1,292.2 49.3,293.5 49.3,294.4 50.2,294.4 "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "68.6,306.1 66.6,304.6 64.5,304.8 64.5,306.1 63.8,306.1 63.1,305.6 59.4,304.7 59.4,302.3 54.8,302.7  53.4,303.5 51.5,303.5 50.6,303.4 48.4,304.6 48.4,307 43.8,310.3 44.2,311.7 45.2,311.7 44.9,313 44.3,313.3 44.2,316.8  48.2,321.2 49.9,321.2 50,321 53.1,321 54,320.1 55.7,320.1 56.7,321.1 59.3,321.4 59,324.8 61.9,329.9 60.4,332.9 60.5,334.2  61.7,335.4 61.7,338.7 63.3,340.8 63.3,343.6 67.9,343.6 70,341.4 70,306.1 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.8,300.8l-0.8,0.1v-1.8l0.6-0.7l0.3-0.1v-10.9h-1.4l-0.2-0.7l1.6-0.1v-1.9l-1.6-0.7l-5.2,0.2l-2.9,1.5 l-1.1,1.9l-1.9,0.8l-0.8,0.9l0.2,1l1,0.1l0.6,1.5l1.7-0.7l0.3,2h-0.5l-1.4-0.2l-1.6,0.3l-1.5,2.1l-2.1,0.3l-0.3,1.8l0.9,0.2 l-0.3,1.2l-2.1-0.4l-2,0.4l-0.4,1.1l0.3,2.3l1.1,0.5h1.9l1.3-0.1l0.4-1l2-2.6l1.3,0.3l1.3-1.2l0.2,0.9l3.2,2.2l-0.4,0.5l-1.5-0.1 l0.6,0.8l0.9,0.2l1.1-0.4v-1.3l0.5-0.2l-0.4-0.4l-2.2-1.2l-0.6-1.6h1.8l0.6,0.6l1.6,1.3l0.1,1.6l1.6,1.7l0.6-2.3l1.1-0.6l0.2,1.9 l1.1,1.2H70v-1.8L69.8,300.8z M66.2,286.6l-2,1.2v0.9l1.2,0.5l0.1,1.1l-1.7,2.4h-2.8l-0.2-0.6l1.8-0.9v-3.4l3-2.1h0.7L66.2,286.6z"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 175.5,
    y: 353.6,
    transform: "matrix(1 -2.268920e-03 2.268920e-03 1 -0.8113 0.5972)",
    className: "st4",
    width: 174.5,
    height: 8.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M383.8,269.1c0,8.7-7,15.8-15.7,15.8c-8.7,0-15.8-7-15.8-15.7s7-15.8,15.7-15.8c0,0,0,0,0,0 C376.8,253.3,383.8,260.3,383.8,269.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M368.3,258.3h0.6c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0,0.2,0,0.5,0,0.7v1.2c0,1.7,0,3.5,0,5.2 l8.6,4.3c0,1,0,1.9,0,2.9l0,0l-8.6-2.5c0,1.3,0,2.6,0,3.9c0.9,0.6,1.7,1.2,2.6,1.9v1.8h-0.1c-0.1-0.1-0.2-0.1-0.3-0.1l-0.6-0.3 l-2.1-0.9l-0.7-0.3c0,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.3,0.1l-0.7,0.3c-0.8,0.3-1.5,0.6-2.2,0.9l-0.8,0.3c-0.1,0-0.2,0.1-0.3,0.1 s0,0,0,0c0-0.2,0-0.3,0-0.5v-0.9c0-0.1,0-0.3,0-0.5c0.9-0.6,1.9-1.2,2.8-1.9c0-1.3,0-2.6,0-3.9l0,0c0,0-0.1,0-0.1,0l-0.5,0.1 c-0.4,0.2-0.9,0.2-1.4,0.4c-1.1,0.4-2.3,0.7-3.4,1c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.1-0.8,0.2-1.1,0.3 c-0.1,0-0.2,0.1-0.4,0.1s-0.1,0.1-0.2,0s0,0,0,0c0-0.1,0-0.1,0-0.2v-0.5c0-0.5,0-0.9,0-1.4c0-0.2,0-0.5,0-0.7l8.7-4.3 c0-0.8,0-1.5,0-2.3c0-1.1,0-2.3,0-3.4c-0.1-0.6,0-1.2,0.1-1.7c0.1-0.3,0.3-0.5,0.6-0.7c0.1-0.1,0.2-0.1,0.3-0.2 C368.2,258.3,368.2,258.3,368.3,258.3z"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    y: 161.2,
    className: "st7",
    width: 262,
    height: 395
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M275.9,208.7h208.7c9.1,0,16.4,7.3,16.4,16.4v316.2c0,9.1-7.3,16.4-16.4,16.4H275.9c-9.1,0-16.4-7.3-16.4-16.4 V225.1C259.5,216.1,266.8,208.7,275.9,208.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M793.8,0.7c-2.3,0.1-10-3.8-32.3,8c-7.5,4-27,20.6-51.6,41.6l-78,1.5l-19.1,10.7l68.4,12.3 c-16.1,13.6-33.1,27.7-49.8,40.8L580.7,105l-9.6,7.6l51.2,28.2l-1.1,24l13.2-7.6l3.5-17.2c25.7-11.9,50.3-26.1,73.6-42.2l9.3,57.8 l13.4-14.1l3.5-62.4c72-53.3,72.6-70.9,72.4-75.7C809.9-1.9,796.1,0.6,793.8,0.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M532.8,358.7v-45.3h11.8c13.5,27.6,15.6,32.1,16.3,34.3h0.1c-0.5-5.4-0.5-12.8-0.5-20.2v-14.1h8.4v45.3h-11.3 c-14.5-30.4-16.1-34-16.7-35.7h-0.1c0.3,5.7,0.4,13.6,0.4,21.7v14L532.8,358.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M609.1,341.1c0,10-4.8,18.2-16.4,18.2c-12,0-16.1-8.8-16.1-18.1c0-8.5,4.8-17.5,16.6-17.5 C604.2,323.8,609.1,331.8,609.1,341.1z M585.7,341.1c0,7.3,2.5,11.2,7.3,11.2c4.5,0,7-3.9,7-11.1c0-6.8-2.3-10.3-7.2-10.3 C588.2,330.9,585.7,334.8,585.7,341.1L585.7,341.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M633,313.4h29v7.6h-20v11.5h18.8v7.5H642v18.7h-9V313.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M668.5,358.7v-48.1h9v48.1H668.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M686.2,310.6h9v8.3h-9V310.6z M686.2,324.5h9v34.2h-9V324.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M733.5,355.3c0,10.6-4.3,17.1-16.2,17.1c-11.1,0-14.3-6-14.8-11.1h8.9c0.6,2.7,2.8,4.2,6.4,4.2 c5.7,0,6.9-3.4,6.9-9.6v-2.1c-1.7,3.2-5,4.5-9.2,4.5c-8.2,0-13.6-6.5-13.6-17.1c0-10.9,6.6-17.5,14.2-17.5c5.4,0,7.5,2,8.3,3.8 c0.1-1.1,0.2-2.1,0.4-3.1h8.7c-0.1,1.7-0.1,5.5-0.1,10.3L733.5,355.3z M711.2,341.1c0,6.1,2.5,9.9,6.9,9.9c5.1,0,6.9-3,6.9-10 c0-6.3-0.9-9.8-6.7-9.8C714.3,331.2,711.2,334.1,711.2,341.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M750.8,310.6v18c1.6-2.8,4.6-4.8,9.5-4.8c6.1,0,10.8,3.4,10.8,12.4v22.5h-8.9v-21.1c0-3.7-1.2-6.4-5.4-6.4 c-4.3,0-6,2.9-6,8.4v19.1h-9v-48.1H750.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M775.4,324.5h4.8v-9.3h8.9v9.3h6.1v7h-6.1v17.6c0,2.3,0.6,3.3,3.4,3.3c0.7,0,1.3,0,2-0.2v6.2 c-1.8,0.5-3.7,0.7-5.5,0.6c-6.6,0-8.8-2.7-8.8-9v-18.6h-4.8L775.4,324.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M807.8,348.2c0.4,2.9,2.5,4.6,5.9,4.6c3.2,0,4.9-1.2,4.9-3.4s-2-3.1-7.2-4.6c-9.1-2.6-11.2-5.8-11.2-10.7 c0-4.3,2.7-10.4,13-10.4c9.1,0,12.9,4.7,13.3,10.4h-8.8c-0.3-1.8-1.3-3.9-5-3.9c-2.4,0-3.8,1-3.8,3s1.4,2.7,6.3,4 c9.3,2.4,12.2,5.8,12.2,11.3c0,7-5.9,10.8-14,10.8c-8.4,0-13.7-3.7-14.4-11.1L807.8,348.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M550.8,429.4h-20.8v-13h57.5v13h-20.8v63.9h-15.8V429.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M638.1,463.5c0,16.9-8.1,30.9-27.8,30.9c-20.3,0-27.3-14.9-27.3-30.6c0-14.5,8.2-29.7,28.1-29.7 C629.7,434.1,638.1,447.7,638.1,463.5z M598.4,463.4c0,12.4,4.3,19,12.4,19c7.6,0,11.9-6.6,11.9-18.9c0-11.5-4-17.5-12.3-17.5 C602.7,446.1,598.4,452.8,598.4,463.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M699.4,411.7v65.4c0,6.8,0.1,12.8,0.2,16.2h-14.8c-0.3-2.3-0.5-4.6-0.5-6.8c-2.8,5.1-7.1,8-16.3,8 c-14.8,0-22.5-12.1-22.5-30c0-17.5,9.3-30.3,25-30.3c8.7,0,12.4,3,13.7,5.3v-27.7H699.4z M661.1,463.8c0,10.9,3.7,18.2,11.9,18.2 c10,0,11.9-6.8,11.9-18.1c0-12.4-2.5-17.4-11.4-17.4C666,446.6,661.1,452.3,661.1,463.8L661.1,463.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M760,478.3c0,5,0.3,10,0.8,15h-13.4c-0.5-2.3-0.8-4.6-0.9-7c-2.4,4.7-7.9,8-16.3,8c-14.4,0-19.4-9-19.4-17.7 c0-10.5,7.2-19.1,27.4-19.1h6.8v-4.2c0-4.8-1.5-8.4-8.3-8.4s-8.4,3.5-8.9,7.7h-14.7c0.6-9.2,6.1-18.5,23.9-18.5 c13.7,0,23,4.7,23,19.1L760,478.3z M745.6,467.3h-7.1c-10.4,0-12.4,4.2-12.4,8.1s2.4,7.4,8.2,7.4c9.1,0,11.2-6.1,11.2-14.3V467.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M782.6,435.3c6.8,24.7,10.7,38.2,11.6,44.8h0.1c1.6-7.2,6.8-27.4,11.7-44.8h15.3l-19.8,60.5 c-6.1,18.6-13.3,20.8-23.1,20.8c-2,0-3.9-0.2-5.8-0.5v-12.3c1.8,0.2,3.5,0.3,5.3,0.3c4.8,0,7.4-3.1,8.8-8l-20.3-60.8L782.6,435.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M321.7,498h-6.1v16.4h3.4v-6.3h2.4c3.6,0,6.1-1.8,6.1-5.2S324.8,498,321.7,498z M321.2,505.4H319v-4.8h2.3 c1.6,0,2.8,0.7,2.8,2.3C324.1,504.8,323,505.4,321.2,505.4L321.2,505.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M334.8,498c-0.2,0.7-4.8,15.8-5,16.4h3.3l1.2-3.9h5.4l1.2,3.9h3.5l-5.3-16.4H334.8z M334.8,507.8 c0.9-2.8,1.6-5.4,2-7.2l0,0c0.4,1.5,1.1,3.9,2.1,7.2H334.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M355.2,504.4c-2.3-0.7-3.1-1-3.1-2.2s0.7-1.8,2.2-1.8c1.2-0.2,2.4,0.7,2.5,2c0,0.1,0,0.1,0,0.2h3.3 c-0.2-2.7-1.9-4.7-5.8-4.7c-3.1,0-5.6,1.7-5.6,4.7c0,2.4,1.3,3.7,5.1,4.8c2.4,0.7,3.3,1.3,3.3,2.8c0,1.2-0.7,2-2.5,2 c-1.5,0.2-2.8-0.9-3-2.4c0,0,0,0,0,0h-3.3c0.2,3.3,2.5,5.1,6.1,5.1c4.3,0,6.1-2.3,6.1-5C360.5,507.3,359.4,505.6,355.2,504.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M371.9,504.4c-2.3-0.7-3.1-1-3.1-2.2s0.7-1.8,2.2-1.8c1.2-0.2,2.4,0.7,2.5,2c0,0.1,0,0.1,0,0.2h3.3 c-0.2-2.7-1.9-4.7-5.8-4.7c-3.1,0-5.6,1.7-5.6,4.7c0,2.4,1.3,3.7,5.1,4.8c2.4,0.7,3.3,1.3,3.3,2.8c0,1.2-0.6,2-2.5,2 c-1.5,0.2-2.8-0.9-3-2.5c0,0,0,0,0,0H365c0.2,3.3,2.5,5.1,6.1,5.1c4.3,0,6.1-2.3,6.1-5C377.2,507.3,376.1,505.6,371.9,504.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M388.6,498h-6.1v16.4h3.4v-6.3h2.4c3.6,0,6.1-1.8,6.1-5.2S391.7,498,388.6,498z M388.1,505.4h-2.2v-4.8h2.3 c1.6,0,2.8,0.7,2.8,2.3C391,504.8,389.9,505.4,388.1,505.4L388.1,505.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M406.6,497.8c-5.2,0-7.5,4.3-7.5,8.3c0,4.7,2.2,8.6,7.2,8.6s7.5-3.8,7.5-8.5 C413.9,501.7,411.6,497.8,406.6,497.8z M406.5,512c-2.6,0-3.9-2.6-3.9-5.9s1.1-5.7,3.9-5.7c2.9,0,4,2.7,4,5.7 C410.4,509.6,409.4,512,406.5,512z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M431.3,502.4c0-2.9-2.2-4.5-5.3-4.5h-6.7v16.4h3.3v-6.8h2.2c2.1,0,2.8,0.7,2.8,2.5v0.4c-0.1,1.3,0,2.6,0.3,3.8 h3.2c-0.1-1.2-0.2-2.5-0.2-3.7v-0.4c0-2-0.6-3.3-2.2-4C430.4,505.7,431.5,504.2,431.3,502.4z M425.1,505h-2.5v-4.3h3 c1.3,0,2.4,0.6,2.4,2.1C428,504.6,426.7,505,425.1,505L425.1,505z"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "434.9,498 434.9,500.8 439.3,500.8 439.3,514.4 442.7,514.4 442.7,500.8 447.2,500.8 447.2,498 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 158.7,
    y1: 382.7,
    x2: 158.7,
    y2: 243.7
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M419.4,409.6L419.4,409.6c19.9-20.5,19.9-53.1,0-73.6l0,0l-0.6-0.6l-0.4-0.4l-0.1-0.1c-0.3-0.3-0.6-0.6-1-0.9 l-0.1-0.1c-1.4-1.3-2.9-2.5-4.4-3.7l-0.1,0l-1-0.8l-0.2-0.1l-1-0.7l-0.2-0.2l-1-0.6l-0.2-0.1l-1.1-0.7l-0.1-0.1 c-1.2-0.7-2.5-1.4-3.8-2l0,0l-0.1,0l-1.1-0.5l-0.2-0.1l-1-0.5l-0.3-0.1l-1-0.4l-0.3-0.1l-1-0.4l-0.3-0.1l-1.1-0.4l-0.2-0.1 c-1.4-0.4-2.7-0.8-4.1-1.1l-0.2,0l-1.2-0.2l-0.4-0.1l-1-0.2l-0.5-0.1l-0.9-0.1l-0.5-0.1l-0.9-0.1l-0.5-0.1l-0.9-0.1l-0.5,0l-0.9-0.1 h-0.5h-1h-0.5h-1.4l0,0H380h-0.5h-1H378l-0.9,0.1l-0.5,0l-0.9,0.1l-0.5,0.1l-0.9,0.1l-0.5,0.1l-0.9,0.1l-0.5,0.1l-1,0.2l-0.4,0.1 l-1.2,0.3h-0.2c-1.4,0.3-2.8,0.7-4.1,1.1l-0.2,0.1l-1.1,0.4l-0.3,0.1l-1.1,0.4l-0.3,0.1l-1,0.4l-0.3,0.1l-1,0.5l-0.2,0.1l-1.1,0.5 l-0.1,0l0,0c-1.3,0.6-2.6,1.3-3.8,2l-0.1,0.1l-1.1,0.7l-0.2,0.1l-1,0.6l-0.2,0.2l-1,0.7l-0.2,0.1c-0.4,0.3-0.7,0.5-1.1,0.8l0,0 c-1.2,0.9-2.3,1.8-3.4,2.7l-0.1,0.1l-1,0.9l-0.1,0.1c-0.3,0.3-0.6,0.6-0.9,0.9l-0.1,0.1l-0.3,0.3c-1.3,1.3-2.5,2.6-3.6,4l0,0l0,0 c-15.8,19.5-15.8,47.4,0,66.8l0,0l0,0c1.1,1.4,2.3,2.7,3.6,4l0.3,0.3l0.1,0.1l0.9,0.9l0.1,0.1l1,0.9l0.1,0.1c1.1,1,2.2,1.9,3.4,2.7 l0,0l1.1,0.8l0.2,0.1l1,0.7l0.2,0.2l1,0.6l0.2,0.2l1.1,0.6l0.1,0.1c1.2,0.7,2.5,1.4,3.8,2l0,0h0.1l1.1,0.5l0.2,0.1l1,0.4l0.3,0.1 l1,0.4l0.3,0.1l1,0.4l0.3,0.1l1.1,0.4l0.2,0.1c1.4,0.4,2.7,0.8,4.1,1.1h0.2l1.2,0.3l0.4,0.1l1,0.2l0.5,0.1l0.9,0.1l0.5,0.1l0.9,0.1 l0.5,0.1l0.9,0.1h0.5l0.9,0.1h0.5h1h0.5h1.5l0,0h1.4h0.5h1h0.5l0.9-0.1h0.5l0.9-0.1l0.5-0.1l0.9-0.1l0.5-0.1l0.9-0.1l0.5-0.1l1-0.2 l0.4-0.1c0.4-0.1,0.8-0.2,1.2-0.2h0.2c0.9-0.2,1.9-0.5,2.8-0.7l0,0l1.3-0.4l0.2-0.1l1.1-0.4l0.3-0.1l1-0.4l0.3-0.1l1-0.4l0.3-0.1 l1-0.4l0.2-0.1l1.1-0.5l0.1-0.1h0c1.3-0.6,2.6-1.3,3.8-2l0.1-0.1l1.1-0.7l0.2-0.1l1-0.6l0.2-0.2l1-0.7l0.2-0.1l1-0.8l0.1,0 c1.5-1.1,3-2.4,4.4-3.7l0.1-0.1c0.3-0.3,0.6-0.6,1-0.9l0.1-0.1l0.4-0.4L419.4,409.6z M418.3,405.9l-0.7,0.7l-0.1,0.2l-0.7,0.8 l-0.1,0.1l-0.8,0.8l-0.1,0.1l-0.9,0.8l0,0c-2.4,2.2-5.1,4.2-7.9,5.9l-0.1,0.1l-1,0.5l-0.2,0.1l-0.8,0.5l-0.3,0.2 c-0.2,0.1-0.5,0.3-0.7,0.4l-0.4,0.2l-0.7,0.3l-0.4,0.2l-0.7,0.3l-0.5,0.2l-0.7,0.3l-0.5,0.2l-0.6,0.3l-0.6,0.2l-0.6,0.2l-0.6,0.2 l-0.6,0.2l-0.6,0.2l-0.7,0.2l-0.6,0.2l-0.9,0.2l-0.8,0.2c3.5-3.1,6.4-6.9,8.6-11.1c1.3-2.6,2.5-5.2,3.4-7.9 C409.8,402.8,414.1,404.2,418.3,405.9L418.3,405.9z M367.8,420.4l-0.5-0.2l-0.7-0.2l-0.6-0.2l-0.6-0.2l-0.6-0.2l-0.6-0.2l-0.6-0.2 l-0.6-0.3l-0.5-0.2l-0.7-0.3l-0.5-0.2l-0.7-0.3l-0.4-0.2l-0.7-0.3L359,417l-0.7-0.4l-0.3-0.2l-0.8-0.5l-0.2-0.1l-1-0.6h-0.1 c-2.8-1.7-5.4-3.7-7.8-5.9l0,0l-0.9-0.8l-0.1-0.1l-0.8-0.8l-0.1-0.1l-0.7-0.8l-0.1-0.2c-0.2-0.2-0.5-0.5-0.7-0.7l0-0.1 c4.2-1.6,8.6-3,13-4c1,2.7,2.1,5.4,3.4,7.9c2.1,4.2,5,8,8.5,11.1l-0.7-0.2L367.8,420.4z M331.9,374.4h20.9 c0.1,8.2,1.3,16.4,3.6,24.3c-4.8,1.2-9.5,2.7-14.1,4.5C335.8,394.9,332.2,384.8,331.9,374.4L331.9,374.4z M342.3,342.3 c4.6,1.8,9.3,3.3,14.1,4.5c-2.3,7.9-3.5,16.1-3.6,24.3h-20.9C332.2,360.6,335.9,350.6,342.3,342.3L342.3,342.3z M344.5,339.6 c0.2-0.2,0.5-0.5,0.7-0.7l0.1-0.2c0.2-0.3,0.5-0.5,0.7-0.8l0.1-0.1l0.8-0.8l0.1-0.1l0.9-0.8l0,0c2.4-2.2,5.1-4.2,7.9-5.9l0.1-0.1 l0.9-0.5l0.3-0.2l0.8-0.4l0.4-0.2l0.7-0.4l0.4-0.2l0.6-0.3l0.5-0.2l0.7-0.3l0.5-0.2l0.6-0.3l0.5-0.2l0.6-0.2l0.6-0.2l0.6-0.2 l0.6-0.2l0.6-0.2l0.6-0.2l0.7-0.2l0.6-0.2l0.9-0.2l0.8-0.2c-3.5,3.1-6.4,6.9-8.5,11.1c-1.3,2.6-2.5,5.2-3.4,7.9 C353,342.6,348.7,341.3,344.5,339.6L344.5,339.6z M395,325l0.6,0.2l0.7,0.2l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2 l0.5,0.2l0.7,0.3l0.5,0.2l0.7,0.3l0.5,0.2l0.6,0.3l0.4,0.2l0.7,0.4l0.4,0.2l0.8,0.4l0.3,0.2l0.9,0.5l0.1,0.1 c2.8,1.7,5.4,3.7,7.9,5.9l0,0c0.3,0.3,0.6,0.5,0.9,0.8l0.1,0.1l0.8,0.8l0.1,0.1l0.7,0.8c0,0.1,0.1,0.1,0.1,0.1l0.7,0.8v0.1 c-4.2,1.6-8.5,3-13,4c-1-2.7-2.1-5.4-3.4-7.9c-2.1-4.2-5-8-8.5-11.1l0.8,0.2L395,325z M430.9,371.1H410c-0.1-8.2-1.3-16.4-3.6-24.3 c4.8-1.2,9.5-2.7,14.1-4.5C426.9,350.6,430.6,360.6,430.9,371.1L430.9,371.1z M402,397.7c-13.6-2.6-27.5-2.6-41.1,0l-1.2,0.3 c-2.3-7.7-3.5-15.6-3.5-23.6h50.6c-0.1,8-1.3,15.9-3.5,23.6L402,397.7z M402.2,401.1c-0.9,2.4-1.9,4.8-3.1,7.1 c-4.6,8.7-10.8,14.1-17.6,14.1l0,0c-6.8,0-13-5.4-17.6-14.1c-1.2-2.3-2.2-4.7-3.1-7.1l0.8-0.2c13.1-2.6,26.7-2.6,39.8,0L402.2,401.1 z M356.2,371.1c0.1-8,1.3-15.9,3.5-23.6l1.2,0.2c13.6,2.6,27.5,2.6,41.1-0.1l1.2-0.2c2.3,7.7,3.5,15.6,3.5,23.6L356.2,371.1z  M360.8,344.4c0.9-2.4,1.9-4.8,3.1-7.1c4.6-8.7,10.8-14.1,17.6-14.1l0,0c6.8,0,13,5.4,17.6,14.1c1.2,2.3,2.2,4.7,3.1,7.1l-0.8,0.2 c-13.1,2.6-26.7,2.6-39.8,0L360.8,344.4z M406.4,398.7c2.3-7.9,3.5-16.1,3.6-24.3h20.9c-0.3,10.4-4,20.5-10.4,28.8 C415.9,401.4,411.2,399.9,406.4,398.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoflights);
export default __webpack_public_path__ + "static/media/noflights.3799bf43025362b8920f1b03cef09e4f.svg";
export { ForwardRef as ReactComponent };